export const CatalogTrackerWrapper = {
  flexGrow: 1,
  display: "flex",
  flexDirection: "column",
  minHeight: 0,
  margin: "0px 20px",
};

export const CatalogTrackerContentWrapper = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
};

export const CatalogTrackerTabsWrapper = {
  borderRadius: "8px",
  background: "#EEEEEE",
  width: "fit-content",
  display: "flex",
  height: "40px",
  padding: "4px",
  justifyContent: "space-between",
  marginTop: "16px",
};

export const TabsStyle = {
  "& .Mui-selected": {
    color: "white !important",
  },
  padding: "0",
  minHeight: "32px",
};

export const TabStyle = {
  minHeight: "40px",
  maxHeight: "40px",
  minWidth: "210px",
  fontWeight: 600,
  borderBottom: "none",
  fontFamily: "Lato",
  fontSize: "14px",
  padding: 0,
};

export const BottomContent = {
  display: "flex",
  alignItems: "baseline",
  flexDirection: "column",
  justifyContent: "end",
  background: "white",
  borderRadius: "8px",
  flexGrow: 1,
  marginTop: "20px",
  padding: "0px 20px",
  minHeight: 0,
};
